export { default } from "./useTeacherSubjectPost";
